export enum App {
  website = 'website',
  checkout = 'checkout',
  pos = 'pos',
  selfcare = 'selfcare',
  support = 'support',
  smartwatch = 'smartwatch',
  roamingAuth = 'roaming-auth',
}
